import Dispatcher from "../Dispatcher";
import {Store} from "flux/utils";
import {AddressCountry} from "../models/AddressCountry";
import {AddressState} from "../models/AddressState";
import {ISOGeographicAction} from "../actions/ISOGeographicActions";
import $ = require("jquery");

let countries: Array<AddressCountry> = [];
let states: { [country: string]: Array<AddressState> } = {};
let baseApiUrl = window.emanagerBaseApiAddress;
let websiteId = window.websiteId;

class ISOGeographicStore extends Store<ISOGeographicAction<Array<AddressCountry> | Array<AddressState>>>
{
	constructor(dispatcher:any)
	{
		super(dispatcher);
		this.loadCountries();
	}

	getCountries() { return countries; }

	getStates(country: string): Array<AddressState>
	{
		const state = states[country];
		if (state === null || state === undefined)
		{
			this.loadStatesForCountry(country);
			return [];
		}
		return state;
	}
	private ensureWebsiteId()
	{
		if(!websiteId)
			websiteId = window.websiteId;
		if(!baseApiUrl)
			baseApiUrl = window.emanagerBaseApiAddress;
	}
	private loadCountries()
	{
		this.ensureWebsiteId();
		$.ajax({
				url: `${baseApiUrl}website/${websiteId}/countrystate/countries/all`,
				method: "GET",
				contentType: "application/json"
			})
			.done((countries: Array<AddressCountry>) =>
			{
				let i = 0;
				let len = countries.length;
				let newList = [];
				for(i;i<len;i++)
				{
					let country = countries[i];
					if (country.alpha3Code === "USA")
						newList.push(country);
				}
				this.getDispatcher().dispatch(new ISOGeographicAction("LOADED_COUNTRIES", newList));
			});
	}

	private loadStatesForCountry(countryCode: string)
	{
		this.ensureWebsiteId();
		const country = this.findCountryByCode(countryCode);
		if (country === null || country === undefined)
		{
			return;
		}

		$.ajax({
				url: `${baseApiUrl}website/${websiteId}/countrystate/statesbycountry/${country.id}`,
				method: "GET",
				contentType: "application/json"
			})
			.done((states: Array<AddressState>) =>
			{
				for (var i = 0; i < states.length; i++)
				{
					var state = states[i];
					var codeArr = state.code.split("-");
					var code = codeArr[codeArr.length - 1];
					state.code = code;
				}
				this.getDispatcher().dispatch(new ISOGeographicAction("LOADED_STATES", states));
			});
	}

	findCountryByCode(countryCode: string): AddressCountry
	{
		const foundCountries = countries.filter((country) => { return country.code === countryCode; });
		if (foundCountries.length === 1)
		{
			return foundCountries[0];
		}
		return null;
	}

	// ReSharper disable once InconsistentNaming required because of base class
	__onDispatch(action: ISOGeographicAction<Array<AddressCountry> | Array<AddressState>>)
	{
		switch (action.type)
		{
			case "LOADED_COUNTRIES":
			{
				countries = action.value as Array<AddressCountry>;
				this.__emitChange();
				break;
			}
			case "LOADED_STATES":
			{
				let loadedStates = action.value as Array<AddressState>;
				if (loadedStates.length > 0)
				{
					states[loadedStates[0].countryCode] = loadedStates;
					this.__emitChange();
				}
				break;
			}
			default:
		}
	}

	findStateByCode(countryCode: string, stateCode: string): AddressState
	{
		const sts = states[countryCode];
		if (sts)
		{
			for (var i = 0; i < sts.length; i++)
			{
				var state = sts[i];
				if (state.code === stateCode)
				{
					return state;
				}
			}
		}
		return new AddressState();
	}
}

export default new ISOGeographicStore(Dispatcher);



// WEBPACK FOOTER //
// ./src/stores/ISOGeographicStore.ts